/**
 * Agent Monitor 공용 포매터/클립보드 헬퍼.
 *
 * 모든 탭에서 동일한 UX 를 보장하기 위해 날짜/시간 포맷과 clipboard fallback 을 여기에 모은다.
 */

/**
 * ISO 문자열 또는 epoch ms 를 "짧은 날짜 · 짧은 시간" 포맷(ko-KR)으로 표시.
 * 주로 테이블에서 "언제 실행됐나" 를 보여줄 때 사용.
 */
export function formatTimestamp(value: string | number | null | undefined): string {
  if (value == null || value === "") return "—";
  try {
    const d = typeof value === "number" ? new Date(value) : new Date(value);
    return d.toLocaleString("ko-KR", { dateStyle: "short", timeStyle: "short" });
  } catch {
    return String(value);
  }
}

/**
 * ISO 문자열을 "월/일 시/분" 포맷(ko-KR)으로 짧게 표시.
 * 버킷 브라우저/파이프라인의 "최근 수정" 컬럼처럼 공간이 좁을 때 사용.
 */
export function formatShortDate(iso?: string | null): string {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("ko-KR", {
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

/**
 * navigator.clipboard 우선, 실패 시 textarea fallback 으로 텍스트 복사.
 */
export async function copyToClipboard(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  }
}
